import { createRequiredContext } from '../createRequiredContext';
const { useContext, Provider, Context, Consumer } = createRequiredContext('DataCapsuleProvider');
export const DataCapsuleProvider = Provider;
export const DataCapsuleConsumer = Consumer;
export const DataCapsuleContext = Context;
export const useDataCapsule = useContext;
//# sourceMappingURL=DataCapsuleProvider.js.map